// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import type { ApiCodeResponse } from './base';
import { ensureCodeOk } from './base';

export type AdminUser = {
  id: number;
  phone: string;
  nickname: string;
  avatar?: string;
  role: 'admin' | 'super_admin' | string;
  status: 0 | 1;
  last_login_at?: string | null;
  created_at?: string;
  updated_at?: string;
};

export async function getCurrentAdminUserInfo(options?: { [key: string]: any }) {
  const res = await request<ApiCodeResponse<AdminUser>>('/api/v1/admin/userinfo', {
    method: 'GET',
    skipErrorHandler: true,
    ...(options || {}),
  });
  return ensureCodeOk(res);
}

export type CreateAdminUserBody = {
  phone: string;
  nickname: string;
  password?: string;
  role?: 'admin' | 'super_admin';
};

export async function createAdminUser(body: CreateAdminUserBody, options?: { [key: string]: any }) {
  const res = await request<ApiCodeResponse<AdminUser>>('/api/v1/admin/users', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    skipErrorHandler: true,
    ...(options || {}),
  });
  return ensureCodeOk(res);
}

export type AdminUserListQuery = {
  page?: number;
  page_size?: number;
};

export type AdminUserListData = {
  list: AdminUser[];
  total: number;
  page: number;
  page_size: number;
};

export async function getAdminUsers(params: AdminUserListQuery, options?: { [key: string]: any }) {
  const res = await request<ApiCodeResponse<AdminUserListData>>('/api/v1/admin/users', {
    method: 'GET',
    params,
    skipErrorHandler: true,
    ...(options || {}),
  });
  return ensureCodeOk(res);
}

export type UpdateAdminUserBody = {
  nickname?: string;
  password?: string;
  role?: 'admin' | 'super_admin';
  status?: 0 | 1;
};

export async function updateAdminUser(
  id: number,
  body: UpdateAdminUserBody,
  options?: { [key: string]: any },
) {
  const res = await request<ApiCodeResponse<AdminUser>>(`/api/v1/admin/users/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    skipErrorHandler: true,
    ...(options || {}),
  });
  return ensureCodeOk(res);
}

export async function deleteAdminUser(id: number, options?: { [key: string]: any }) {
  const res = await request<ApiCodeResponse>(`/api/v1/admin/users/${id}`, {
    method: 'DELETE',
    skipErrorHandler: true,
    ...(options || {}),
  });
  return ensureCodeOk(res);
}

export async function toggleAdminUserStatus(id: number, options?: { [key: string]: any }) {
  const res = await request<ApiCodeResponse<{ status: 0 | 1 }>>(`/api/v1/admin/users/${id}/status`, {
    method: 'POST',
    skipErrorHandler: true,
    ...(options || {}),
  });
  return ensureCodeOk(res);
}

